(function () {
  "use strict";
  function z(l) {
    const t = {};
    for (const e of l.steps)
      e.required && e.options.length > 0 && (t[e.id] = e.options[0].value);
    return { configVersion: l.configVersion, selections: t };
  }
  function L(l, t) {
    const e = l.steps.find((c) => c.id === "shell_color"),
      a = t.selections.shell_color ?? "",
      i = e == null ? void 0 : e.options.find((c) => c.value === a),
      n = (i == null ? void 0 : i.priceDelta) ?? 0,
      o = ["visor", "side_plates", "top_plate"],
      s = [];
    for (const c of o) {
      const u = t.selections[c];
      if (!u) continue;
      const _ = l.steps.find((f) => f.id === c);
      if (!_) continue;
      const m = _.options.find((f) => f.value === u);
      !m ||
        m.priceDelta === 0 ||
        s.push({ stepId: c, label: m.label, price: m.priceDelta });
    }
    const r = [];
    for (const c of l.upsells) {
      const u = `_upsell_${c.id}`;
      if (t.selections[u] === "true") {
        let _ = c.price;
        if (c.variants && c.variants.length > 0) {
          const m = `_upsell_${c.id}_variant`,
            f = t.selections[m],
            v = f
              ? c.variants.find((y) => String(y.variantId) === f)
              : c.variants[0];
          v && (_ = v.price);
        }
        r.push({ id: c.id, label: c.label, price: _ });
      }
    }
    const p = s.reduce((c, u) => c + u.price, 0),
      g = r.reduce((c, u) => c + u.price, 0),
      d = l.basePrice + n + p + g;
    return {
      basePrice: l.basePrice,
      multicamSurcharge: n,
      accessories: s,
      upsells: r,
      total: d,
    };
  }
  function P(l, t) {
    const e = [];
    for (const a of l.steps) {
      const i = t.selections[a.id];
      if (!i) continue;
      const n = a.options.find((s) => s.value === i);
      if (!n || !n.previewLayerId) continue;
      const o = l.previewLayers.find((s) => s.id === n.previewLayerId);
      o && e.push(o);
    }
    return e.sort((a, i) => a.zIndex - i.zIndex);
  }
  function N(l) {
    const t = [],
      e = ["shell_color", "size", "visor", "side_plates", "top_plate"];
    for (const a of e) {
      const i = l.selections[a];
      if (!i) throw new Error(`Missing required selection: ${a}`);
      t.push(i.toUpperCase().replace(/_/g, ""));
    }
    return t.join("-");
  }
  function S(l, t) {
    const e = [],
      a = t.selections.shell_color,
      i = t.selections.size;
    if (!a) throw new Error("Missing required selection: shell_color");
    if (!i) throw new Error("Missing required selection: size");
    const n = l.variantMappings.find((r) => r.color === a && r.size === i);
    if (!n)
      throw new Error(`No variant mapping found for color="${a}" size="${i}"`);
    const o = N(t);
    e.push({
      id: n.variantId,
      quantity: 1,
      properties: {
        _g35_config_code: o,
        _g35_role: "helmet",
        _g35_shell_color: a,
        _g35_size: i,
      },
    });
    const s = ["visor", "side_plates", "top_plate"];
    for (const r of s) {
      const p = t.selections[r];
      if (!p) continue;
      const g = l.steps.find((u) => u.id === r);
      if (!g) continue;
      const d = g.options.find((u) => u.value === p);
      if (!d || d.priceDelta === 0) continue;
      const c = l.accessoryMappings.find(
        (u) => u.stepId === r && u.optionValue === p,
      );
      if (!c)
        throw new Error(
          `No accessory mapping found for step="${r}" option="${p}"`,
        );
      e.push({
        id: c.variantId,
        quantity: 1,
        properties: {
          _g35_parent_config: o,
          _g35_role: r,
          _g35_option: d.cartLabel ?? d.label,
        },
      });
    }
    for (const r of l.upsells) {
      const p = `_upsell_${r.id}`;
      if (t.selections[p] === "true") {
        let g = r.variantId,
          d = r.cartLabel ?? r.label;
        if (r.variants && r.variants.length > 0) {
          const c = `_upsell_${r.id}_variant`,
            u = t.selections[c],
            _ = u
              ? r.variants.find((m) => String(m.variantId) === u)
              : r.variants[0];
          _ && ((g = _.variantId), (d = `${r.cartLabel ?? r.label} — ${_.cartLabel ?? _.label}`));
        }
        e.push({
          id: g,
          quantity: 1,
          properties: {
            _g35_parent_config: o,
            _g35_role: `upsell_${r.id}`,
            _g35_option: d,
          },
        });
      }
    }
    return { items: e };
  }
  const E = [
    { size: "XS", cm: "53 – 54", inch: '20⅞" – 21¼"', face: "" },
    { size: "S", cm: "54 – 55", inch: '21¼" – 21⅝"', face: '67 cm / 26⅜"' },
    { size: "M", cm: "55 – 56", inch: '21⅝" – 22"', face: "" },
    { size: "L", cm: "56 – 58", inch: '22" – 22⅞"', face: '69 cm / 27⅛"' },
    { size: "XL", cm: "58 – 59", inch: '22⅞" – 23¼"', face: "" },
    { size: "XXL", cm: "60 – 61", inch: '23⅝" – 24"', face: '73 cm / 28¾"' },
    { size: "XXXL", cm: "62 – 63", inch: '24⅜" – 24¾"', face: '74 cm / 29"' },
  ];
  class C {
    constructor(t, e) {
      (this.root = t),
        (this.options = e),
        (this.openStepId = "shell_color"),
        (this.sidePlateColor = ""),
        (this.expandedUpsellId = ""),
        (this.lastTotal = 0),
        (this.floatingBar = null),
        (this.scrollObserver = null),
        (this.pricingVisible = !0),
        (this.cartVisible = !0),
        (this.state = z(e.config)),
        (this.translations = e.translations ?? {});
      const a = this.state.selections.side_plates ?? "standard";
      if (a !== "standard") {
        const i = a.lastIndexOf("_");
        i > 0 && (this.sidePlateColor = a.substring(0, i));
      }
    }
    mount() {
      this.render();
    }
    get avail() {
      return this.options.availability;
    }
    t(key, fallback, variables = {}) {
      return g35Translate(this.translations, key, fallback, variables);
    }
    isVariantInStock(t) {
      return this.avail ? this.avail.variants[String(t)] !== !1 : !0;
    }
    getProductionTime(t) {
      return this.avail ? (this.avail.productionTimes[t] ?? "") : "";
    }
    isHelmetVariantInStock() {
      const { config: t } = this.options,
        e = this.state.selections.shell_color,
        a = this.state.selections.size;
      if (!e || !a) return !0;
      const i = t.variantMappings.find((n) => n.color === e && n.size === a);
      return i ? this.isVariantInStock(i.variantId) : !0;
    }
    isAccessoryInStock(t, e) {
      const { config: a } = this.options,
        i = a.accessoryMappings.find(
          (n) => n.stepId === t && n.optionValue === e,
        );
      return i ? this.isVariantInStock(i.variantId) : !0;
    }
    getStockLabel(t, e) {
      var n, o;
      if (!this.avail) return "";
      const { config: a } = this.options;
      if (t.id === "shell_color") return "";
      if (t.id === "size") {
        const s =
          this.state.selections.shell_color ??
          ((o =
            (n = a.steps.find((p) => p.id === "shell_color")) == null
              ? void 0
              : n.options[0]) == null
            ? void 0
            : o.value);
        if (!s) return "";
        const r = a.variantMappings.find(
          (p) => p.color === s && p.size === e.value,
        );
        return r
          ? this.isVariantInStock(r.variantId)
            ? this.t("in_stock", "In Stock")
            : this.t("production_status", "Production — {{ production_time }}", { production_time: this.getProductionTime(a.productHandle) || this.t("made_to_order", "made to order") })
          : "";
      }
      if (e.priceDelta === 0 && !e.hex) return "";
      const i = a.accessoryMappings.find(
        (s) => s.stepId === t.id && s.optionValue === e.value,
      );
      return i
        ? this.isVariantInStock(i.variantId)
          ? this.t("in_stock", "In Stock")
          : this.t("production_status", "Production — {{ production_time }}", { production_time: this.getProductionTime(i.productHandle) || this.t("made_to_order", "made to order") })
        : "";
    }
    getUpsellStockLabel(t, e) {
      if (!this.avail) return "";
      const a = e ?? t.variantId;
      return this.isVariantInStock(a)
        ? this.t("in_stock", "In Stock")
        : this.t("production_status", "Production — {{ production_time }}", { production_time: this.getProductionTime(t.productHandle) || this.t("made_to_order", "made to order") });
    }
    getBuildStockStatus() {
      if (!this.avail) return { inStock: !0, productionTime: "" };
      const { config: t } = this.options;
      if (!this.isHelmetVariantInStock())
        return {
          inStock: !1,
          productionTime: this.getProductionTime(t.productHandle),
        };
      const e = ["visor", "side_plates", "top_plate"];
      for (const a of e) {
        const i = this.state.selections[a];
        if (!i) continue;
        const n = t.steps.find((r) => r.id === a);
        if (!n) continue;
        const o = n.options.find((r) => r.value === i);
        if (!o || o.priceDelta === 0) continue;
        const s = t.accessoryMappings.find(
          (r) => r.stepId === a && r.optionValue === i,
        );
        if (s && !this.isVariantInStock(s.variantId))
          return {
            inStock: !1,
            productionTime: this.getProductionTime(s.productHandle),
          };
      }
      for (const a of t.upsells) {
        const i = `_upsell_${a.id}`;
        if (this.state.selections[i] !== "true") continue;
        const n = `_upsell_${a.id}_variant`,
          o = this.state.selections[n]
            ? Number(this.state.selections[n])
            : a.variantId;
        if (!this.isVariantInStock(o))
          return {
            inStock: !1,
            productionTime: this.getProductionTime(a.productHandle),
          };
      }
      return { inStock: !0, productionTime: "" };
    }
    render() {
      const t = document.createElement("div");
      t.className = "g35-configurator";
      const e = this.createPreviewPanel(),
        a = this.createFormPanel();
      t.append(e, a), this.root.replaceChildren(t), this.setupFloatingBar();
    }
    createPreviewPanel() {
      const { config: t } = this.options,
        e = document.createElement("aside");
      (e.className = "g35-configurator__preview"),
        e.setAttribute("aria-label", this.t("preview_aria", "Cookie G35 live preview"));
      const a = document.createElement("div");
      a.className = "g35-configurator__preview-stage";
      const i = P(t, this.state);
      if (i.length > 0)
        i.forEach((o) => {
          const s = document.createElement("img");
          (s.className = "g35-configurator__preview-image"),
            (s.src = o.src),
            (s.alt = o.alt),
            (s.style.zIndex = String(o.zIndex)),
            o.opacity !== void 0 && (s.style.opacity = String(o.opacity)),
            (s.loading = o.zIndex === 1 ? "eager" : "lazy"),
            a.append(s);
        });
      else {
        const o = document.createElement("div");
        (o.className = "g35-configurator__preview-placeholder"),
          (o.textContent = this.t("preview_placeholder", "Select options to preview your helmet")),
          a.append(o);
      }
      const n = this.createPricingDisplay();
      return (
        n.classList.add("g35-configurator__pricing--desktop"), e.append(a, n), e
      );
    }
    formatPrice(t, e = !1) {
      const a = t % 1 === 0 ? t.toFixed(0) : t.toFixed(2);
      return `${e ? "+" : ""}€${a}`;
    }
    createPricingDisplay() {
      const { config: t } = this.options,
        e = L(t, this.state),
        a =
          e.multicamSurcharge > 0 ||
          e.accessories.length > 0 ||
          e.upsells.length > 0,
        i = document.createElement("div");
      i.className = "g35-configurator__pricing";
      const n = document.createElement("div");
      n.className = "g35-configurator__price-header";
      const o = document.createElement("span");
      (o.className = "g35-configurator__price-label"),
        (o.textContent = this.t("your_build", "Your Build"));
      const s = document.createElement("span");
      if (
        ((s.className = "g35-configurator__price-total"),
        (s.textContent = this.formatPrice(e.total)),
        this.lastTotal !== 0 &&
          this.lastTotal !== e.total &&
          s.classList.add("g35-configurator__price-total--flash"),
        (this.lastTotal = e.total),
        n.append(o, s),
        i.append(n),
        this.avail)
      ) {
        const r = this.getBuildStockStatus(),
          p = document.createElement("div");
        (p.className = r.inStock
          ? "g35-configurator__build-status g35-configurator__build-status--in-stock"
          : "g35-configurator__build-status g35-configurator__build-status--production"),
          (p.textContent = r.inStock
            ? `✓ ${this.t("in_stock", "In Stock")}`
            : `⏱ ${this.t("production_status", "Production — {{ production_time }}", { production_time: r.productionTime || this.t("made_to_order", "made to order") })}`),
          i.append(p);
      }
      if (a) {
        const r = document.createElement("div");
        r.className = "g35-configurator__price-breakdown";
        const p = document.createElement("div");
        if (
          ((p.className = "g35-configurator__price-line"),
          (p.innerHTML = `<span>${g35EscapeHtml(this.t("g35_helmet", "G35 Helmet"))}</span><span>${this.formatPrice(e.basePrice)}</span>`),
          r.append(p),
          e.multicamSurcharge > 0)
        ) {
          const c = document.createElement("div");
          (c.className =
            "g35-configurator__price-line g35-configurator__price-line--addon"),
            (c.innerHTML = `<span>${g35EscapeHtml(this.t("multicam_finish", "Multicam finish"))}</span><span>${this.formatPrice(e.multicamSurcharge, !0)}</span>`),
            r.append(c);
        }
        const g = {
          visor: this.t("step.visor", "Visor"),
          side_plates: this.t("step.side_plates", "Side Plates"),
          top_plate: this.t("step.top_plate", "Top Plate"),
        };
        e.accessories.forEach((c) => {
          const u = document.createElement("div");
          u.className =
            "g35-configurator__price-line g35-configurator__price-line--addon";
          const _ = g[c.stepId] ? `${g[c.stepId]}: ${c.label}` : c.label;
          (u.innerHTML = `<span>${_}</span><span>${this.formatPrice(c.price, !0)}</span>`),
            r.append(u);
        }),
          e.upsells.forEach((c) => {
            const u = document.createElement("div");
            (u.className =
              "g35-configurator__price-line g35-configurator__price-line--addon"),
              (u.innerHTML = `<span>${c.label}</span><span>${this.formatPrice(c.price, !0)}</span>`),
              r.append(u);
          });
        const d = document.createElement("div");
        (d.className =
          "g35-configurator__price-line g35-configurator__price-line--total"),
          (d.innerHTML = `<span>${g35EscapeHtml(this.t("total", "Total"))}</span><span>${this.formatPrice(e.total)}</span>`),
          r.append(d),
          i.append(r);
      }
      return i;
    }
    createFormPanel() {
      const { config: t } = this.options,
        e = document.createElement("div");
      e.className = "g35-configurator__form";
      for (const i of t.steps) e.append(this.createStep(i));
      e.append(this.createUpsellSection());
      const a = this.createPricingDisplay();
      return (
        a.classList.add("g35-configurator__pricing--mobile"),
        e.append(a),
        e.append(this.createCartSection()),
        e
      );
    }
    createStep(t) {
      const e = document.createElement("details");
      (e.className = "g35-configurator__step"),
        (e.dataset.stepId = t.id),
        (e.open = this.openStepId === t.id);
      const a = document.createElement("summary");
      a.className = "g35-configurator__step-summary";
      const i = document.createElement("h3");
      i.textContent = t.label;
      const n = this.createSelectedIndicator(t);
      return (
        a.append(i),
        n && a.append(n),
        a.addEventListener("click", (o) => {
          o.preventDefault(),
            (this.openStepId = e.open ? "" : t.id),
            this.render();
        }),
        e.append(a),
        t.id === "side_plates"
          ? e.append(this.createSidePlateOptions(t))
          : t.id === "size"
            ? e.append(this.createSizeOptions(t))
            : e.append(this.createOptionGrid(t)),
        e
      );
    }
    createSelectedIndicator(t) {
      const e = this.state.selections[t.id];
      if (!e) return null;
      const a = t.options.find((o) => o.value === e);
      if (!a) return null;
      const i = document.createElement("span");
      if (((i.className = "g35-configurator__selected-label"), a.hex)) {
        const o = document.createElement("span");
        (o.className = "g35-configurator__selected-chip"),
          (o.style.backgroundColor = a.hex),
          i.append(o);
        const s = document.createElement("span");
        (s.textContent = a.label), i.append(s);
      } else i.textContent = a.label;
      const n = this.getStockLabel(t, a);
      if (n) {
        const o = document.createElement("span");
        (o.className =
          n === this.t("in_stock", "In Stock")
            ? "g35-configurator__stock-badge g35-configurator__stock-badge--in-stock"
            : "g35-configurator__stock-badge g35-configurator__stock-badge--production"),
          (o.textContent = n),
          i.append(o);
      }
      return i;
    }
    createOptionGrid(t) {
      const e = document.createElement("div");
      e.className = "g35-configurator__options";
      for (const a of t.options) e.append(this.createOptionButton(t, a));
      return e;
    }
    createSizeOptions(t) {
      const e = document.createElement("div");
      e.className = "g35-configurator__size-wrapper";
      const a = document.createElement("button");
      (a.type = "button"),
        (a.className = "g35-configurator__size-guide-link"),
        (a.innerHTML =
          `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 12h20"/><path d="M6 8v8"/><path d="M10 10v4"/><path d="M14 10v4"/><path d="M18 8v8"/></svg> ${g35EscapeHtml(this.t("size_link_prefix", "Not sure about your size?"))} <span class="g35-configurator__size-guide-cta">${g35EscapeHtml(this.t("size_link_cta", "Find it here"))}</span>`),
        a.addEventListener("click", () => this.showSizeGuide()),
        e.append(a);
      const i = document.createElement("div");
      i.className = "g35-configurator__options";
      for (const n of t.options) i.append(this.createOptionButton(t, n));
      return e.append(i), e;
    }
    showSizeGuide() {
      const t = document.querySelector(".g35-size-modal");
      t && t.remove();
      const e = document.createElement("div");
      e.className = "g35-size-modal";
      const a = document.createElement("div");
      (a.className = "g35-size-modal__dialog"),
        a.setAttribute("role", "dialog"),
        a.setAttribute("aria-label", this.t("size_modal_aria", "Cookie G35 Size Guide"));
      const i = document.createElement("div");
      i.className = "g35-size-modal__header";
      const n = document.createElement("h3");
      n.textContent = this.t("size_modal_title", "Cookie G35 Size Guide");
      const o = document.createElement("button");
      (o.type = "button"),
        (o.className = "g35-size-modal__close"),
        (o.innerHTML = "&times;"),
        o.setAttribute("aria-label", this.t("close", "Close")),
        o.addEventListener("click", () => e.remove()),
        i.append(n, o);
      const s = document.createElement("div");
      s.className = "g35-size-modal__guides";
      const r = document.createElement("div");
      (r.className = "g35-size-modal__guide"),
        (r.innerHTML =
          `<img src="https://cdn.shopify.com/s/files/1/0758/1191/4071/files/head-circ.png?v=1779039931" alt="${g35EscapeHtml(this.t("head_measurement_alt", "Head circumference measurement"))}" class="g35-size-modal__img"/><span class="g35-size-modal__guide-label">${g35EscapeHtml(this.t("head_measurement_label", "Head circumference"))}</span><span class="g35-size-modal__guide-desc">${g35EscapeHtml(this.t("head_measurement_copy", "Measure around the widest part, ~1 cm above eyebrows and ears"))}</span>`);
      const p = document.createElement("div");
      (p.className = "g35-size-modal__guide"),
        (p.innerHTML =
          `<img src="https://cdn.shopify.com/s/files/1/0758/1191/4071/files/face-circ.png?v=1779039931" alt="${g35EscapeHtml(this.t("face_measurement_alt", "Face circumference measurement"))}" class="g35-size-modal__img"/><span class="g35-size-modal__guide-label">${g35EscapeHtml(this.t("face_measurement_label", "Face circumference"))}</span><span class="g35-size-modal__guide-desc">${g35EscapeHtml(this.t("face_measurement_copy", "Wrap tape over the crown, down in front of the ears, and under the chin"))}</span>`),
        s.append(r, p);
      const g = document.createElement("table");
      (g.className = "g35-size-modal__table"),
        (g.innerHTML = `
      <thead><tr><th>${g35EscapeHtml(this.t("modal_table_size", "Size"))}</th><th>${g35EscapeHtml(this.t("modal_table_head_cm", "Head (cm)"))}</th><th>${g35EscapeHtml(this.t("modal_table_head_in", "Head (in)"))}</th><th>${g35EscapeHtml(this.t("modal_table_max_face", "Max Face"))}</th></tr></thead>
      <tbody>${E.map((c) => `<tr><td>${c.size}</td><td>${c.cm}</td><td>${c.inch}</td><td>${c.face || "—"}</td></tr>`).join("")}</tbody>
    `);
      const d = document.createElement("p");
      (d.className = "g35-size-modal__tip"),
        (d.textContent = this.t("modal_tip", "If your face circumference exceeds the maximum shown, choose the next size up. Between sizes? Go larger for comfort.")),
        a.append(i, s, g, d),
        e.append(a),
        document.body.append(e),
        e.addEventListener("click", (c) => {
          c.target === e && e.remove();
        });
    }
    createSidePlateOptions(t) {
      const e = document.createElement("div");
      e.className = "g35-configurator__side-plates-wrapper";
      const a = this.state.selections[t.id] ?? "standard",
        i = a === "standard",
        n = [
          { key: "black", label: this.t("color.black", "Black"), hex: "#1a1a1a" },
          { key: "blue", label: this.t("color.blue", "Blue"), hex: "#2563eb" },
          { key: "purple", label: this.t("color.purple", "Purple"), hex: "#7c3aed" },
          { key: "red", label: this.t("color.red", "Red"), hex: "#dc2626" },
          { key: "green", label: this.t("color.green", "Green"), hex: "#16a34a" },
          { key: "orange", label: this.t("color.orange", "Orange"), hex: "#ea580c" },
          { key: "gray", label: this.t("color.gray", "Gray"), hex: "#6b7280" },
          { key: "pink", label: this.t("color.pink", "Pink"), hex: "#ec4899" },
          { key: "yellow", label: this.t("color.yellow", "Yellow"), hex: "#eab308" },
        ],
        o = document.createElement("div");
      o.className = "g35-configurator__options";
      const s = document.createElement("button");
      (s.type = "button"),
        (s.className =
          "g35-configurator__option g35-configurator__swatch g35-configurator__swatch--none"),
        s.setAttribute("aria-pressed", String(i)),
        s.setAttribute("aria-label", this.t("side_standard_included", "Standard (Included)")),
        (s.title = this.t("side_standard_included", "Standard (Included)"));
      const r = document.createElement("span");
      (r.className =
        "g35-configurator__swatch-chip g35-configurator__swatch-chip--x"),
        s.append(r);
      const p = document.createElement("span");
      (p.className = "g35-configurator__swatch-tooltip"),
        (p.textContent = this.t("side_standard", "Standard")),
        s.append(p),
        s.addEventListener("click", () => {
          (this.sidePlateColor = ""),
            (this.state = {
              ...this.state,
              selections: { ...this.state.selections, [t.id]: "standard" },
            }),
            this.render();
        }),
        o.append(s);
      for (const g of n) {
        const d = this.sidePlateColor === g.key,
          c = document.createElement("button");
        (c.type = "button"),
          (c.className = "g35-configurator__swatch"),
          c.setAttribute("aria-pressed", String(d)),
          c.setAttribute("aria-label", g.label),
          (c.title = g.label);
        const u = document.createElement("span");
        (u.className = "g35-configurator__swatch-chip"),
          (u.style.backgroundColor = g.hex),
          c.append(u);
        const _ = document.createElement("span");
        (_.className = "g35-configurator__swatch-tooltip"),
          (_.textContent = `${g.label} +€40`),
          c.append(_),
          c.addEventListener("click", () => {
            this.sidePlateColor = g.key;
            const m = `${g.key}_g35`,
              f = t.options.find((v) => v.value === m);
            f &&
              (this.state = {
                ...this.state,
                selections: { ...this.state.selections, [t.id]: f.value },
              }),
              this.render();
          }),
          o.append(c);
      }
      if ((e.append(o), this.sidePlateColor)) {
        const g = [
            { key: "g35", label: this.t("side_design.g35", "G35 Logo") },
            { key: "loop", label: this.t("side_design.loop", "Loop") },
            { key: "camo", label: this.t("side_design.camo", "Camo") },
          ],
          d = document.createElement("span");
        (d.className = "g35-configurator__sp-design-label"),
          (d.textContent = this.t("side_design_label", "Design")),
          e.append(d);
        const c = document.createElement("div");
        c.className = "g35-configurator__sp-designs";
        for (const u of g) {
          const _ = `${this.sidePlateColor}_${u.key}`,
            m = document.createElement("button");
          (m.type = "button"),
            (m.className = "g35-configurator__sp-design-btn"),
            a === _ &&
              m.classList.add("g35-configurator__sp-design-btn--active"),
            (m.textContent = u.label),
            m.addEventListener("click", () => {
              const f = t.options.find((v) => v.value === _);
              f &&
                (this.state = {
                  ...this.state,
                  selections: { ...this.state.selections, [t.id]: f.value },
                }),
                this.render();
            }),
            c.append(m);
        }
        e.append(c);
      }
      return e;
    }
    createOptionButton(t, e) {
      const a = this.state.selections[t.id] === e.value,
        i = t.type === "swatch" && (!!e.hex || !!e.swatchImage),
        n =
          e.value === "none" && e.priceDelta === 0 && !e.hex && !e.swatchImage,
        o = document.createElement("button");
      if (
        ((o.type = "button"),
        (o.className =
          i || n
            ? "g35-configurator__option g35-configurator__swatch"
            : "g35-configurator__option"),
        n && o.classList.add("g35-configurator__swatch--none"),
        (o.dataset.stepId = t.id),
        (o.dataset.optionValue = e.value),
        o.setAttribute("aria-pressed", String(a)),
        o.setAttribute("aria-label", e.label),
        (o.title = e.label),
        n)
      ) {
        const s = document.createElement("span");
        (s.className =
          "g35-configurator__swatch-chip g35-configurator__swatch-chip--x"),
          o.append(s);
      } else if (i) {
        const s = document.createElement("span");
        (s.className = "g35-configurator__swatch-chip"),
          e.hex && (s.style.backgroundColor = e.hex),
          e.swatchImage &&
            ((s.style.backgroundImage = `url("${e.swatchImage}")`),
            s.classList.add("g35-configurator__swatch-chip--multicam"),
            e.swatchOpacity != null &&
              (s.style.opacity = String(e.swatchOpacity))),
          o.append(s);
        const r = document.createElement("span");
        r.className = "g35-configurator__swatch-tooltip";
        let p =
          e.priceDelta > 0
            ? `${e.label} ${this.formatPrice(e.priceDelta, !0)}`
            : e.label;
        const g = this.getStockLabel(t, e);
        g && (p += ` · ${g}`), (r.textContent = p), o.append(r);
      } else {
        const s = document.createElement("span");
        if (
          ((s.className = "g35-configurator__option-label"),
          (s.textContent = e.label),
          o.append(s),
          e.priceDelta > 0)
        ) {
          const r = document.createElement("span");
          (r.className = "g35-configurator__option-price"),
            (r.textContent = this.formatPrice(e.priceDelta, !0)),
            o.append(r);
        }
      }
      return (
        o.addEventListener("click", () => {
          (this.state = {
            ...this.state,
            selections: { ...this.state.selections, [t.id]: e.value },
          }),
            this.render();
        }),
        o
      );
    }
    createUpsellSection() {
      const { config: t } = this.options,
        e = document.createElement("section");
      e.className = "g35-configurator__upsells";
      const a = document.createElement("h3");
      (a.textContent = this.t("complete_setup", "Complete Your Setup")), e.append(a);
      for (const i of t.upsells) e.append(this.createUpsellCard(i));
      return e;
    }
    createUpsellCard(t) {
      const e = `_upsell_${t.id}`,
        a = this.state.selections[e] === "true",
        i = t.variants && t.variants.length > 0,
        n = this.expandedUpsellId === t.id,
        o = document.createElement("div");
      if (
        ((o.className = "g35-configurator__upsell-card"),
        a && o.classList.add("g35-configurator__upsell-card--added"),
        t.image || o.classList.add("g35-configurator__upsell-card--no-image"),
        t.image)
      ) {
        const d = document.createElement("img");
        (d.className = "g35-configurator__upsell-img"),
          (d.src = t.image),
          (d.alt = t.label),
          (d.loading = "lazy"),
          o.append(d);
      }
      const s = document.createElement("div");
      s.className = "g35-configurator__upsell-info";
      const r = document.createElement("strong");
      r.textContent = t.label;
      const p = document.createElement("p");
      if (((p.textContent = t.description), s.append(r, p), t.productHandle)) {
        const h = document.createElement("a");
        (h.className = "g35-configurator__upsell-product-link"),
          (h.href = `/products/${t.productHandle}`),
          (h.target = "_blank"),
          (h.rel = "noopener"),
          (h.textContent = this.t("view_product", "View product")),
          s.append(h);
      }
      if (this.avail) {
        const d = this.getUpsellStockLabel(t);
        if (d) {
          const c = document.createElement("span"),
            u = d === this.t("in_stock", "In Stock");
          (c.className = `g35-configurator__stock-badge ${u ? "g35-configurator__stock-badge--in-stock" : "g35-configurator__stock-badge--production"}`),
            (c.textContent = d),
            s.append(c);
        }
      }
      if (!i) {
        const d = document.createElement("span");
        (d.className = "g35-configurator__upsell-price"),
          (d.textContent = this.formatPrice(t.price)),
          s.append(d);
      } else if (!a && t.variants && t.variants.length > 0) {
        const d = document.createElement("span"),
          minPrice = t.variants.reduce(
            (m, v) => (v.price < m ? v.price : m),
            t.variants[0].price,
          );
        (d.className = "g35-configurator__upsell-price"),
          (d.textContent = `From ${this.formatPrice(minPrice)}`),
          s.append(d);
      }
      const g = document.createElement("button");
      if (
        ((g.type = "button"),
        (g.className = "g35-configurator__upsell-toggle"),
        i && !a
          ? ((g.textContent = n ? this.t("cancel", "Cancel") : this.t("add", "Add")),
            g.addEventListener("click", () => {
              (this.expandedUpsellId = n ? "" : t.id), this.render();
            }))
          : ((g.textContent = a ? this.t("remove", "Remove") : this.t("add", "Add")),
            g.setAttribute("aria-pressed", String(a)),
            g.addEventListener("click", () => {
              (this.state = {
                ...this.state,
                selections: {
                  ...this.state.selections,
                  [e]: a ? "false" : "true",
                },
              }),
                a && (this.expandedUpsellId = ""),
                this.render();
            })),
        o.append(s, g),
        i && (n || a))
      ) {
        const d = `_upsell_${t.id}_variant`,
          c = this.state.selections[d] || String(t.variants[0].variantId),
          u = document.createElement("div");
        u.className = "g35-configurator__upsell-variants";
        for (const _ of t.variants) {
          const m = String(_.variantId) === c,
            f = document.createElement("button");
          (f.type = "button"),
            (f.className = "g35-configurator__upsell-variant-btn"),
            m &&
              f.classList.add("g35-configurator__upsell-variant-btn--active");
          const v = document.createElement("span");
          (v.className = "g35-configurator__upsell-variant-name"),
            (v.textContent = _.label);
          const y = document.createElement("span");
          if (
            ((y.className = "g35-configurator__upsell-variant-price"),
            (y.textContent = this.formatPrice(_.price)),
            f.append(v, y),
            this.avail)
          ) {
            const k = this.getUpsellStockLabel(t, _.variantId);
            if (k) {
              const w = document.createElement("span"),
                j = k === this.t("in_stock", "In Stock");
              (w.className = `g35-configurator__stock-badge ${j ? "g35-configurator__stock-badge--in-stock" : "g35-configurator__stock-badge--production"}`),
                (w.textContent = k),
                f.append(w);
            }
          }
          f.addEventListener("click", () => {
            (this.state = {
              ...this.state,
              selections: {
                ...this.state.selections,
                [d]: String(_.variantId),
                [e]: "true",
              },
            }),
              (this.expandedUpsellId = ""),
              this.render();
          }),
            u.append(f);
        }
        o.append(u);
      }
      return o;
    }
    createCartSection() {
      const t = document.createElement("div");
      if (
        ((t.className = "g35-configurator__cart-section"), this.statusMessage)
      ) {
        const a = document.createElement("p");
        (a.className = "g35-configurator__status"),
          (a.textContent = this.statusMessage),
          t.append(a);
      }
      const e = document.createElement("button");
      return (
        (e.type = "button"),
        (e.className = "g35-configurator__cart-button"),
        (e.textContent = this.t("add_to_cart", "Add to Cart")),
        e.addEventListener("click", () => {
          this.handleAddToCart();
        }),
        t.append(e),
        t
      );
    }
    setupFloatingBar() {
      this.floatingBar &&
        (this.floatingBar.remove(), (this.floatingBar = null)),
        this.scrollObserver &&
          (this.scrollObserver.disconnect(), (this.scrollObserver = null));
      const { config: t } = this.options,
        e = L(t, this.state),
        a = document.createElement("div");
      a.className = "g35-configurator__floating-bar";
      const i = document.createElement("div");
      i.className = "g35-configurator__floating-bar-price";
      const n = document.createElement("span");
      (n.className = "g35-configurator__floating-bar-label"),
        (n.textContent = this.t("your_build", "Your Build"));
      const o = document.createElement("span");
      (o.className = "g35-configurator__floating-bar-total"),
        (o.textContent = this.formatPrice(e.total)),
        i.append(n, o);
      const s = document.createElement("button");
      (s.type = "button"),
        (s.className = "g35-configurator__floating-bar-cta"),
        (s.textContent = this.t("add_to_cart", "Add to Cart")),
        s.addEventListener("click", () => this.handleAddToCart()),
        a.append(i, s),
        document.body.append(a),
        (this.floatingBar = a);
      const r = this.root.querySelector(".g35-configurator__pricing--desktop"),
        p = this.root.querySelector(".g35-configurator__pricing--mobile"),
        g = this.root.querySelector(".g35-configurator__cart-section");
      if (!g) return;
      let d = !1,
        c = !1;
      (this.scrollObserver = new IntersectionObserver(
        (u) => {
          for (const m of u)
            m.target === r && (d = m.isIntersecting),
              m.target === p && (c = m.isIntersecting),
              m.target === g && (this.cartVisible = m.isIntersecting);
          this.pricingVisible = d || c;
          const _ = !this.pricingVisible && !this.cartVisible;
          a.classList.toggle("g35-configurator__floating-bar--visible", _);
        },
        { threshold: 0 },
      )),
        r && this.scrollObserver.observe(r),
        p && this.scrollObserver.observe(p),
        this.scrollObserver.observe(g);
    }
    async handleAddToCart() {
      const { config: t } = this.options;
      try {
        const e = S(t, this.state),
          a = await fetch(this.t("cart_add_url", "/cart/add.js"), {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(e),
          });
        if (!a.ok) throw new Error(`Cart API returned ${a.status}`);
        (this.statusMessage = this.t("added_to_cart", "Added to cart!")),
          this.render(),
          setTimeout(() => {
            window.location.href = this.t("cart_url", "/cart");
          }, 800);
      } catch (e) {
        console.error("Cookie G35 add-to-cart failed", e),
          (this.statusMessage = this.t("cart_error", "Unable to add to cart. Please try again.")),
          this.render();
      }
    }
  }
  function h(l, t, e) {
    const a = l[t];
    if (typeof a != "string" || a.length === 0)
      throw new Error(`${e}: "${t}" must be a non-empty string`);
    return a;
  }
  function b(l, t, e) {
    const a = l[t];
    if (typeof a != "number" || isNaN(a))
      throw new Error(`${e}: "${t}" must be a number`);
    return a;
  }
  function I(l, t, e) {
    const a = l[t];
    if (!Array.isArray(a)) throw new Error(`${e}: "${t}" must be an array`);
    return a;
  }
  function G(l, t) {
    if (typeof l != "object" || l === null)
      throw new Error(`${t}: option must be an object`);
    const e = l;
    return {
      id: typeof e.id == "string" ? e.id : e.value,
      label: h(e, "label", t),
      value: h(e, "value", t),
      hex: typeof e.hex == "string" ? e.hex : void 0,
      swatchImage: typeof e.swatchImage == "string" ? e.swatchImage : void 0,
      swatchOpacity:
        typeof e.swatchOpacity == "number" ? e.swatchOpacity : void 0,
      priceDelta: typeof e.priceDelta == "number" ? e.priceDelta : 0,
      previewLayerId:
        typeof e.previewLayerId == "string" ? e.previewLayerId : void 0,
    };
  }
  function V(l, t) {
    const e = `steps[${t}]`;
    if (typeof l != "object" || l === null)
      throw new Error(`${e}: must be an object`);
    const a = l,
      i = I(a, "options", e).map((n, o) => G(n, `${e}.options[${o}]`));
    if (i.length === 0) throw new Error(`${e}: must have at least one option`);
    return {
      id: h(a, "id", e),
      label: h(a, "label", e),
      type: h(a, "type", e),
      required: a.required === !0,
      options: i,
    };
  }
  function X(l, t) {
    const e = `previewLayers[${t}]`;
    if (typeof l != "object" || l === null)
      throw new Error(`${e}: must be an object`);
    const a = l;
    return {
      id: h(a, "id", e),
      src: h(a, "src", e),
      alt: h(a, "alt", e),
      zIndex: b(a, "zIndex", e),
      opacity: typeof a.opacity == "number" ? a.opacity : void 0,
    };
  }
  function H(l, t) {
    const e = `variantMappings[${t}]`;
    if (typeof l != "object" || l === null)
      throw new Error(`${e}: must be an object`);
    const a = l;
    return {
      color: h(a, "color", e),
      size: h(a, "size", e),
      variantId: b(a, "variantId", e),
    };
  }
  function D(l, t) {
    const e = `accessoryMappings[${t}]`;
    if (typeof l != "object" || l === null)
      throw new Error(`${e}: must be an object`);
    const a = l;
    return {
      stepId: h(a, "stepId", e),
      optionValue: h(a, "optionValue", e),
      productHandle: h(a, "productHandle", e),
      variantId: b(a, "variantId", e),
      price: b(a, "price", e),
    };
  }
  function M(l, t) {
    if (typeof l != "object" || l === null)
      throw new Error(`${t}: variant must be an object`);
    const e = l;
    return {
      label: h(e, "label", t),
      variantId: b(e, "variantId", t),
      price: b(e, "price", t),
    };
  }
  function $(l, t) {
    const e = `upsells[${t}]`;
    if (typeof l != "object" || l === null)
      throw new Error(`${e}: must be an object`);
    const a = l,
      i = Array.isArray(a.variants)
        ? a.variants.map((n, o) => M(n, `${e}.variants[${o}]`))
        : void 0;
    return {
      id: h(a, "id", e),
      label: h(a, "label", e),
      description: h(a, "description", e),
      productHandle: h(a, "productHandle", e),
      variantId: b(a, "variantId", e),
      price: b(a, "price", e),
      image: typeof a.image == "string" ? a.image : "",
      variants: i,
    };
  }
  function T(l) {
    if (typeof l != "object" || l === null)
      throw new Error("Config must be a non-null object");
    const t = l;
    if (t.brand !== "Cookie") throw new Error('Config brand must be "Cookie"');
    if (t.model !== "G35") throw new Error('Config model must be "G35"');
    const e = I(t, "steps", "config").map((s, r) => V(s, r)),
      a = I(t, "previewLayers", "config").map((s, r) => X(s, r)),
      i = I(t, "variantMappings", "config").map((s, r) => H(s, r)),
      n = I(t, "accessoryMappings", "config").map((s, r) => D(s, r)),
      o = I(t, "upsells", "config").map((s, r) => $(s, r));
    return {
      brand: "Cookie",
      model: "G35",
      productHandle: h(t, "productHandle", "config"),
      configVersion: h(t, "configVersion", "config"),
      currency: "EUR",
      basePrice: b(t, "basePrice", "config"),
      steps: e,
      previewLayers: a,
      variantMappings: i,
      accessoryMappings: n,
      upsells: o,
    };
  }
  function g35EscapeHtml(value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }
  function g35ReadTranslations() {
    const node = document.getElementById("g35-translations");
    if (!node || !node.textContent) return {};
    try {
      const parsed = JSON.parse(node.textContent);
      return parsed && typeof parsed === "object" ? parsed : {};
    } catch (error) {
      console.warn("Cookie G35 translations could not be parsed", error);
      return {};
    }
  }
  function g35Translate(translations, key, fallback, variables = {}) {
    const candidate = translations && typeof translations[key] === "string" ? translations[key].trim() : "";
    let value = candidate || fallback;
    for (const [name, replacement] of Object.entries(variables)) {
      value = String(value).replaceAll(`{{ ${name} }}`, String(replacement));
    }
    return String(value);
  }
  function g35Color(translations, value, fallback) {
    return g35Translate(translations, `color.${value}`, fallback);
  }
  function g35OptionLabel(translations, stepId, value, fallback) {
    if (stepId === "shell_color" || stepId === "top_plate") {
      if (stepId === "top_plate" && value === "none") return g35Translate(translations, "option.no_extra_top", fallback);
      return g35Color(translations, value, fallback);
    }
    if (stepId === "visor") {
      if (value === "clear") return g35Translate(translations, "visor.clear", fallback);
      return g35Color(translations, value, fallback);
    }
    if (stepId === "side_plates") {
      if (value === "standard") return g35Translate(translations, "side_standard_included", fallback);
      const separator = value.lastIndexOf("_");
      if (separator > 0) {
        const color = value.substring(0, separator);
        const design = value.substring(separator + 1);
        return `${g35Color(translations, color, color)} ${g35Translate(translations, `side_design.${design}`, design)}`;
      }
    }
    return fallback;
  }
  function g35PreviewAlt(translations, layer) {
    const id = layer.id || "";
    const rules = [
      ["shell_", "shell", "shell_color"],
      ["visor_", "visor", "visor"],
      ["side_", "side_plates", "side_plates"],
      ["top_", "top_plate", "top_plate"],
    ];
    for (const [prefix, component, step] of rules) {
      if (!id.startsWith(prefix)) continue;
      const value = id.slice(prefix.length);
      const componentLabel = g35Translate(translations, `component.${component}`, component);
      const optionLabel = g35OptionLabel(translations, step, value, value);
      return g35Translate(translations, "preview_layer_alt", layer.alt, { component: componentLabel, option: optionLabel });
    }
    return layer.alt;
  }
  function g35LocalizeConfig(config, translations) {
    return {
      ...config,
      steps: config.steps.map((step) => ({
        ...step,
        label: g35Translate(translations, `step.${step.id}`, step.label),
        options: step.options.map((option) => ({
          ...option,
          cartLabel: option.label,
          label: g35OptionLabel(translations, step.id, option.value, option.label),
        })),
      })),
      previewLayers: config.previewLayers.map((layer) => ({
        ...layer,
        alt: g35PreviewAlt(translations, layer),
      })),
      upsells: config.upsells.map((upsell) => ({
        ...upsell,
        cartLabel: upsell.label,
        label: g35Translate(translations, `upsell.${upsell.id}.label`, upsell.label),
        description: g35Translate(translations, `upsell.${upsell.id}.description`, upsell.description),
        variants: upsell.variants
          ? upsell.variants.map((variant) => ({
              ...variant,
              cartLabel: variant.label,
              label: g35Translate(translations, `upsell.${upsell.id}.variant.${variant.variantId}`, variant.label),
            }))
          : undefined,
      })),
    };
  }
  const B = {
    brand: "Cookie",
    model: "G35",
    productHandle: "cookie-g35-skydiving-helmet",
    configVersion: "1.0.0",
    currency: "EUR",
    basePrice: 550,
    steps: [
      {
        id: "shell_color",
        label: "Shell Color",
        type: "swatch",
        required: !0,
        options: [
          {
            value: "white",
            label: "White",
            hex: "#FFFFFF",
            previewLayerId: "shell_white",
          },
          {
            value: "black_matte",
            label: "Black Matte",
            hex: "#1a1a1a",
            previewLayerId: "shell_black_matte",
          },
          {
            value: "charcoal",
            label: "Charcoal",
            hex: "#4a4a4a",
            previewLayerId: "shell_charcoal",
          },
          {
            value: "dark_blue",
            label: "Dark Blue",
            hex: "#1a2d5a",
            previewLayerId: "shell_dark_blue",
          },
          {
            value: "lime",
            label: "Lime",
            hex: "#7ab317",
            previewLayerId: "shell_lime",
          },
          {
            value: "royal_blue",
            label: "Royal Blue",
            hex: "#2563eb",
            previewLayerId: "shell_royal_blue",
          },
          {
            value: "red",
            label: "Red",
            hex: "#dc2626",
            previewLayerId: "shell_red",
          },
          {
            value: "tactical",
            label: "Tactical",
            hex: "#4a5a3a",
            previewLayerId: "shell_tactical",
          },
          {
            value: "multicam_arid",
            label: "Multicam Arid",
            priceDelta: 100,
            swatchImage:
              "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/Multicam-square.png?v=1778983560",
            previewLayerId: "shell_multicam_arid",
          },
        ],
      },
      {
        id: "size",
        label: "Size",
        type: "radio_cards",
        required: !0,
        options: [
          { value: "XS", label: "XS" },
          { value: "S", label: "S" },
          { value: "M", label: "M" },
          { value: "L", label: "L" },
          { value: "XL", label: "XL" },
          { value: "XXL", label: "XXL" },
          { value: "XXXL", label: "XXXL" },
        ],
      },
      {
        id: "visor",
        label: "Visor",
        type: "swatch",
        required: !0,
        options: [
          {
            value: "clear",
            label: "Clear (Included)",
            priceDelta: 0,
            swatchImage:
              "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--visor-clear-swatch.webp?v=1778984407",
          },
          {
            value: "photochromic",
            label: "Photochromic",
            priceDelta: 94,
            previewLayerId: "visor_photochromic",
            swatchImage:
              "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--visor-tint-swatch.webp?v=1778984407",
            swatchOpacity: 0.5,
          },
          {
            value: "blue",
            label: "Blue",
            priceDelta: 74,
            previewLayerId: "visor_blue",
            swatchImage:
              "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--visor-blue-swatch.webp?v=1778984407",
          },
          {
            value: "orange",
            label: "Orange",
            priceDelta: 74,
            previewLayerId: "visor_orange",
            swatchImage:
              "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--visor-orange-swatch.webp?v=1778984407",
          },
          {
            value: "tint",
            label: "Tint",
            priceDelta: 64,
            previewLayerId: "visor_tint",
            swatchImage:
              "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--visor-tint-swatch.webp?v=1778984407",
          },
        ],
      },
      {
        id: "side_plates",
        label: "Side Plates",
        type: "swatch",
        required: !0,
        options: [
          {
            value: "standard",
            label: "Standard (Included)",
            priceDelta: 0,
            previewLayerId: "side_standard",
          },
          {
            value: "black_g35",
            label: "Black G35",
            hex: "#1a1a1a",
            priceDelta: 40,
            previewLayerId: "side_black_g35",
          },
          {
            value: "black_loop",
            label: "Black Loop",
            hex: "#1a1a1a",
            priceDelta: 40,
            previewLayerId: "side_black_loop",
          },
          {
            value: "black_camo",
            label: "Black Camo",
            hex: "#1a1a1a",
            priceDelta: 40,
            previewLayerId: "side_black_camo",
          },
          {
            value: "blue_g35",
            label: "Blue G35",
            hex: "#2563eb",
            priceDelta: 40,
            previewLayerId: "side_blue_g35",
          },
          {
            value: "blue_loop",
            label: "Blue Loop",
            hex: "#2563eb",
            priceDelta: 40,
            previewLayerId: "side_blue_loop",
          },
          {
            value: "blue_camo",
            label: "Blue Camo",
            hex: "#2563eb",
            priceDelta: 40,
            previewLayerId: "side_blue_camo",
          },
          {
            value: "purple_g35",
            label: "Purple G35",
            hex: "#7c3aed",
            priceDelta: 40,
            previewLayerId: "side_purple_g35",
          },
          {
            value: "purple_loop",
            label: "Purple Loop",
            hex: "#7c3aed",
            priceDelta: 40,
            previewLayerId: "side_purple_loop",
          },
          {
            value: "purple_camo",
            label: "Purple Camo",
            hex: "#7c3aed",
            priceDelta: 40,
            previewLayerId: "side_purple_camo",
          },
          {
            value: "red_g35",
            label: "Red G35",
            hex: "#dc2626",
            priceDelta: 40,
            previewLayerId: "side_red_g35",
          },
          {
            value: "red_loop",
            label: "Red Loop",
            hex: "#dc2626",
            priceDelta: 40,
            previewLayerId: "side_red_loop",
          },
          {
            value: "red_camo",
            label: "Red Camo",
            hex: "#dc2626",
            priceDelta: 40,
            previewLayerId: "side_red_camo",
          },
          {
            value: "green_g35",
            label: "Green G35",
            hex: "#16a34a",
            priceDelta: 40,
            previewLayerId: "side_green_g35",
          },
          {
            value: "green_loop",
            label: "Green Loop",
            hex: "#16a34a",
            priceDelta: 40,
            previewLayerId: "side_green_loop",
          },
          {
            value: "green_camo",
            label: "Green Camo",
            hex: "#16a34a",
            priceDelta: 40,
            previewLayerId: "side_green_camo",
          },
          {
            value: "orange_g35",
            label: "Orange G35",
            hex: "#ea580c",
            priceDelta: 40,
            previewLayerId: "side_orange_g35",
          },
          {
            value: "orange_loop",
            label: "Orange Loop",
            hex: "#ea580c",
            priceDelta: 40,
            previewLayerId: "side_orange_loop",
          },
          {
            value: "orange_camo",
            label: "Orange Camo",
            hex: "#ea580c",
            priceDelta: 40,
            previewLayerId: "side_orange_camo",
          },
          {
            value: "gray_g35",
            label: "Gray G35",
            hex: "#6b7280",
            priceDelta: 40,
            previewLayerId: "side_gray_g35",
          },
          {
            value: "gray_loop",
            label: "Gray Loop",
            hex: "#6b7280",
            priceDelta: 40,
            previewLayerId: "side_gray_loop",
          },
          {
            value: "gray_camo",
            label: "Gray Camo",
            hex: "#6b7280",
            priceDelta: 40,
            previewLayerId: "side_gray_camo",
          },
          {
            value: "pink_g35",
            label: "Pink G35",
            hex: "#ec4899",
            priceDelta: 40,
            previewLayerId: "side_pink_g35",
          },
          {
            value: "pink_loop",
            label: "Pink Loop",
            hex: "#ec4899",
            priceDelta: 40,
            previewLayerId: "side_pink_loop",
          },
          {
            value: "pink_camo",
            label: "Pink Camo",
            hex: "#ec4899",
            priceDelta: 40,
            previewLayerId: "side_pink_camo",
          },
          {
            value: "yellow_g35",
            label: "Yellow G35",
            hex: "#eab308",
            priceDelta: 40,
            previewLayerId: "side_yellow_g35",
          },
          {
            value: "yellow_loop",
            label: "Yellow Loop",
            hex: "#eab308",
            priceDelta: 40,
            previewLayerId: "side_yellow_loop",
          },
          {
            value: "yellow_camo",
            label: "Yellow Camo",
            hex: "#eab308",
            priceDelta: 40,
            previewLayerId: "side_yellow_camo",
          },
        ],
      },
      {
        id: "top_plate",
        label: "Top Plate",
        type: "swatch",
        required: !0,
        options: [
          { value: "none", label: "No Extra Top", priceDelta: 0 },
          {
            value: "black",
            label: "Black",
            hex: "#1a1a1a",
            priceDelta: 66,
            previewLayerId: "top_black",
          },
          {
            value: "charcoal",
            label: "Charcoal",
            hex: "#4a4a4a",
            priceDelta: 66,
            previewLayerId: "top_charcoal",
          },
          {
            value: "dark_blue",
            label: "Dark Blue",
            hex: "#1a2d5a",
            priceDelta: 66,
            previewLayerId: "top_dark_blue",
          },
          {
            value: "electric_blue",
            label: "Electric Blue",
            hex: "#2563eb",
            priceDelta: 66,
            previewLayerId: "top_electric_blue",
          },
          {
            value: "lime",
            label: "Lime",
            hex: "#7ab317",
            priceDelta: 66,
            previewLayerId: "top_lime",
          },
          {
            value: "orange",
            label: "Orange",
            hex: "#ea580c",
            priceDelta: 66,
            previewLayerId: "top_orange",
          },
          {
            value: "fluro_pink",
            label: "Fluro Pink",
            hex: "#ec4899",
            priceDelta: 66,
            previewLayerId: "top_pink",
          },
          {
            value: "purple",
            label: "Purple",
            hex: "#7c3aed",
            priceDelta: 66,
            previewLayerId: "top_purple",
          },
          {
            value: "red",
            label: "Red",
            hex: "#dc2626",
            priceDelta: 66,
            previewLayerId: "top_red",
          },
          {
            value: "royal_blue",
            label: "Royal Blue",
            hex: "#2563eb",
            priceDelta: 66,
            previewLayerId: "top_royal_blue",
          },
          {
            value: "tactical_green",
            label: "Tactical Green",
            hex: "#4a5a3a",
            priceDelta: 66,
            previewLayerId: "top_tactical",
          },
          {
            value: "white",
            label: "White",
            hex: "#FFFFFF",
            priceDelta: 66,
            previewLayerId: "top_white",
          },
          {
            value: "yellow",
            label: "Yellow",
            hex: "#eab308",
            priceDelta: 66,
            previewLayerId: "top_yellow",
          },
          {
            value: "multicam_arid",
            label: "Multicam Arid",
            swatchImage:
              "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/Multicam-square.png?v=1778983560",
            priceDelta: 96,
            previewLayerId: "top_multicam_arid",
          },
        ],
      },
    ],
    previewLayers: [
      {
        id: "shell_white",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--WhitePNG_800.webp?v=1778975258",
        alt: "White shell",
        zIndex: 1,
      },
      {
        id: "shell_black_matte",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--BlackPNG_800-1.webp?v=1778975260",
        alt: "Black Matte shell",
        zIndex: 1,
      },
      {
        id: "shell_charcoal",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--CharcoalPNG_800.webp?v=1778975261",
        alt: "Charcoal shell",
        zIndex: 1,
      },
      {
        id: "shell_dark_blue",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--NavyPNG_800.webp?v=1778975262",
        alt: "Dark Blue shell",
        zIndex: 1,
      },
      {
        id: "shell_lime",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--LimePNG_800.webp?v=1778975264",
        alt: "Lime shell",
        zIndex: 1,
      },
      {
        id: "shell_royal_blue",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--RoyalPNG_800.webp?v=1778975265",
        alt: "Royal Blue shell",
        zIndex: 1,
      },
      {
        id: "shell_red",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--RedPNG_800.webp?v=1778975266",
        alt: "Red shell",
        zIndex: 1,
      },
      {
        id: "shell_tactical",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--TacticalPNG_800.webp?v=1778975269",
        alt: "Tactical shell",
        zIndex: 1,
      },
      {
        id: "shell_multicam_arid",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--shell-multicam-arid.png?v=1778978979",
        alt: "Multicam Arid shell",
        zIndex: 1,
      },
      {
        id: "side_standard",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--StandardPNG_800.webp?v=1778975272",
        alt: "Standard side plates",
        zIndex: 2,
      },
      {
        id: "side_black_g35",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--Black-G35PNG_800.webp?v=1778975273",
        alt: "Black G35 side plates",
        zIndex: 2,
      },
      {
        id: "side_black_camo",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--Black-CamoPNG_800.png?v=1778975274",
        alt: "Black Camo side plates",
        zIndex: 2,
      },
      {
        id: "side_black_loop",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--Black-LoopPNG_800.png?v=1778975275",
        alt: "Black Loop side plates",
        zIndex: 2,
      },
      {
        id: "side_blue_g35",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--Blue-G35PNG_800.png?v=1778975277",
        alt: "Blue G35 side plates",
        zIndex: 2,
      },
      {
        id: "side_blue_camo",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--Blue-CamoPNG_800.png?v=1778975277",
        alt: "Blue Camo side plates",
        zIndex: 2,
      },
      {
        id: "side_blue_loop",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--Blue-LoopPNG_800.png?v=1778975278",
        alt: "Blue Loop side plates",
        zIndex: 2,
      },
      {
        id: "side_green_g35",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--Green-G35PNG_800.png?v=1778975279",
        alt: "Green G35 side plates",
        zIndex: 2,
      },
      {
        id: "side_green_camo",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--Green-CamoPNG_800.png?v=1778975280",
        alt: "Green Camo side plates",
        zIndex: 2,
      },
      {
        id: "side_green_loop",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--Green-LoopPNG_800.webp?v=1778975281",
        alt: "Green Loop side plates",
        zIndex: 2,
      },
      {
        id: "side_gray_g35",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--Gray-G35PNG_800.png?v=1778975282",
        alt: "Gray G35 side plates",
        zIndex: 2,
      },
      {
        id: "side_gray_camo",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--Gray-CamoPNG_800.png?v=1778975284",
        alt: "Gray Camo side plates",
        zIndex: 2,
      },
      {
        id: "side_gray_loop",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--Gray-LoopPNG_800.png?v=1778975285",
        alt: "Gray Loop side plates",
        zIndex: 2,
      },
      {
        id: "side_orange_g35",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--Orange-G35PNG_800.png?v=1778975286",
        alt: "Orange G35 side plates",
        zIndex: 2,
      },
      {
        id: "side_orange_camo",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--Orange-CamoPNG_800.png?v=1778975287",
        alt: "Orange Camo side plates",
        zIndex: 2,
      },
      {
        id: "side_orange_loop",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--Orange-LoopPNG_800.png?v=1778975288",
        alt: "Orange Loop side plates",
        zIndex: 2,
      },
      {
        id: "side_pink_g35",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--Pink-G35PNG_800.png?v=1778975290",
        alt: "Pink G35 side plates",
        zIndex: 2,
      },
      {
        id: "side_pink_camo",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--Pink-CamoPNG_800.png?v=1778975291",
        alt: "Pink Camo side plates",
        zIndex: 2,
      },
      {
        id: "side_pink_loop",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--Pink-LoopPNG_800.png?v=1778975292",
        alt: "Pink Loop side plates",
        zIndex: 2,
      },
      {
        id: "side_purple_g35",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--Purple-G35PNG_800.webp?v=1778975293",
        alt: "Purple G35 side plates",
        zIndex: 2,
      },
      {
        id: "side_purple_camo",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--Purple-CamoPNG_800.png?v=1778975294",
        alt: "Purple Camo side plates",
        zIndex: 2,
      },
      {
        id: "side_purple_loop",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--Purple-LoopPNG_800.png?v=1778975295",
        alt: "Purple Loop side plates",
        zIndex: 2,
      },
      {
        id: "side_red_g35",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--Red-G35PNG_800.webp?v=1778975296",
        alt: "Red G35 side plates",
        zIndex: 2,
      },
      {
        id: "side_red_camo",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--Red-CamoPNG_800.png?v=1778975297",
        alt: "Red Camo side plates",
        zIndex: 2,
      },
      {
        id: "side_red_loop",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--Red-LoopPNG_800.png?v=1778975298",
        alt: "Red Loop side plates",
        zIndex: 2,
      },
      {
        id: "side_yellow_g35",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--Yellow-G35PNG_800.png?v=1778975300",
        alt: "Yellow G35 side plates",
        zIndex: 2,
      },
      {
        id: "side_yellow_camo",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--Yellow-CamoPNG_800.png?v=1778975300",
        alt: "Yellow Camo side plates",
        zIndex: 2,
      },
      {
        id: "side_yellow_loop",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--Yellow-LoopPNG_800-1.png?v=1778975302",
        alt: "Yellow Loop side plates",
        zIndex: 2,
      },
      {
        id: "top_black",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--Top-BlackPNG_500.webp?v=1778975303",
        alt: "Black top plate",
        zIndex: 3,
      },
      {
        id: "top_charcoal",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--Top-CharcoalPNG_500.webp?v=1778975304",
        alt: "Charcoal top plate",
        zIndex: 3,
      },
      {
        id: "top_dark_blue",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--Top-NavyPNG_500-1.png?v=1778975305",
        alt: "Dark Blue top plate",
        zIndex: 3,
      },
      {
        id: "top_electric_blue",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--Top-ElectricPNG_500.png?v=1778975306",
        alt: "Electric Blue top plate",
        zIndex: 3,
      },
      {
        id: "top_lime",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--Top-LimePNG_500.png?v=1778975307",
        alt: "Lime top plate",
        zIndex: 3,
      },
      {
        id: "top_orange",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--Top-OrangePNG_500-1.png?v=1778975308",
        alt: "Orange top plate",
        zIndex: 3,
      },
      {
        id: "top_pink",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--Top-PinkPNG_500.webp?v=1778975310",
        alt: "Fluro Pink top plate",
        zIndex: 3,
      },
      {
        id: "top_purple",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--Top-PurplePNG_500-1.png?v=1778975311",
        alt: "Purple top plate",
        zIndex: 3,
      },
      {
        id: "top_red",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--Top-RedPNG_500-1.webp?v=1778975312",
        alt: "Red top plate",
        zIndex: 3,
      },
      {
        id: "top_royal_blue",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--Top-RoyalPNG_500.png?v=1778975314",
        alt: "Royal Blue top plate",
        zIndex: 3,
      },
      {
        id: "top_tactical",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--Top-TacticalPNG_500-1.png?v=1778975315",
        alt: "Tactical Green top plate",
        zIndex: 3,
      },
      {
        id: "top_white",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--Top-WhitePNG_500-1.png?v=1778975316",
        alt: "White top plate",
        zIndex: 3,
      },
      {
        id: "top_yellow",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--Top-YellowPNG_500-1.png?v=1778975317",
        alt: "Yellow top plate",
        zIndex: 3,
      },
      {
        id: "top_multicam_arid",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--multi-arid-top-comp-1000.webp?v=1778975318",
        alt: "Multicam Arid top plate",
        zIndex: 3,
      },
      {
        id: "visor_blue",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--g35-blue-visor.webp?v=1778975321",
        alt: "Blue visor",
        zIndex: 4,
      },
      {
        id: "visor_orange",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--g35-orange-visor.webp?v=1778975322",
        alt: "Orange visor",
        zIndex: 4,
      },
      {
        id: "visor_tint",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--g35-tint-visor-new.webp?v=1778975323",
        alt: "Tint visor",
        zIndex: 4,
      },
      {
        id: "visor_photochromic",
        src: "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/g35--g35-tint-visor-new.webp?v=1778975323",
        alt: "Photochromic visor",
        zIndex: 4,
        opacity: 0.5,
      },
    ],
    variantMappings: [
      { color: "black_matte", size: "XS", variantId: 49862623527255 },
      { color: "black_matte", size: "S", variantId: 49862623789399 },
      { color: "black_matte", size: "M", variantId: 49862624051543 },
      { color: "black_matte", size: "L", variantId: 49862624313687 },
      { color: "black_matte", size: "XL", variantId: 49862624575831 },
      { color: "black_matte", size: "XXL", variantId: 49862624837975 },
      { color: "black_matte", size: "XXXL", variantId: 49862625100119 },
      { color: "charcoal", size: "XS", variantId: 49862623560023 },
      { color: "charcoal", size: "S", variantId: 49862623822167 },
      { color: "charcoal", size: "M", variantId: 49862624084311 },
      { color: "charcoal", size: "L", variantId: 49862624346455 },
      { color: "charcoal", size: "XL", variantId: 49862624608599 },
      { color: "charcoal", size: "XXL", variantId: 49862624870743 },
      { color: "charcoal", size: "XXXL", variantId: 49862625132887 },
      { color: "dark_blue", size: "XS", variantId: 49862623592791 },
      { color: "dark_blue", size: "S", variantId: 49862623854935 },
      { color: "dark_blue", size: "M", variantId: 49862624117079 },
      { color: "dark_blue", size: "L", variantId: 49862624379223 },
      { color: "dark_blue", size: "XL", variantId: 49862624641367 },
      { color: "dark_blue", size: "XXL", variantId: 49862624903511 },
      { color: "dark_blue", size: "XXXL", variantId: 49862625165655 },
      { color: "lime", size: "XS", variantId: 49862623625559 },
      { color: "lime", size: "S", variantId: 49862623887703 },
      { color: "lime", size: "M", variantId: 49862624149847 },
      { color: "lime", size: "L", variantId: 49862624411991 },
      { color: "lime", size: "XL", variantId: 49862624674135 },
      { color: "lime", size: "XXL", variantId: 49862624936279 },
      { color: "lime", size: "XXXL", variantId: 49862625198423 },
      { color: "royal_blue", size: "XS", variantId: 49862623658327 },
      { color: "royal_blue", size: "S", variantId: 49862623920471 },
      { color: "royal_blue", size: "M", variantId: 49862624182615 },
      { color: "royal_blue", size: "L", variantId: 49862624444759 },
      { color: "royal_blue", size: "XL", variantId: 49862624706903 },
      { color: "royal_blue", size: "XXL", variantId: 49862624969047 },
      { color: "royal_blue", size: "XXXL", variantId: 49862625231191 },
      { color: "red", size: "XS", variantId: 49862623691095 },
      { color: "red", size: "S", variantId: 49862623953239 },
      { color: "red", size: "M", variantId: 49862624215383 },
      { color: "red", size: "L", variantId: 49862624477527 },
      { color: "red", size: "XL", variantId: 49862624739671 },
      { color: "red", size: "XXL", variantId: 49862625001815 },
      { color: "red", size: "XXXL", variantId: 49862625263959 },
      { color: "tactical", size: "XS", variantId: 49862623723863 },
      { color: "tactical", size: "S", variantId: 49862623986007 },
      { color: "tactical", size: "M", variantId: 49862624248151 },
      { color: "tactical", size: "L", variantId: 49862624510295 },
      { color: "tactical", size: "XL", variantId: 49862624772439 },
      { color: "tactical", size: "XXL", variantId: 49862625034583 },
      { color: "tactical", size: "XXXL", variantId: 49862625296727 },
      { color: "white", size: "XS", variantId: 49862623756631 },
      { color: "white", size: "S", variantId: 49862624018775 },
      { color: "white", size: "M", variantId: 49862624280919 },
      { color: "white", size: "L", variantId: 49862624543063 },
      { color: "white", size: "XL", variantId: 49862624805207 },
      { color: "white", size: "XXL", variantId: 49862625067351 },
      { color: "white", size: "XXXL", variantId: 49862625329495 },
      { color: "multicam_arid", size: "XS", variantId: 49862707151191 },
      { color: "multicam_arid", size: "S", variantId: 49862707183959 },
      { color: "multicam_arid", size: "M", variantId: 49862707216727 },
      { color: "multicam_arid", size: "L", variantId: 49862707249495 },
      { color: "multicam_arid", size: "XL", variantId: 49862707282263 },
      { color: "multicam_arid", size: "XXL", variantId: 49862707315031 },
      { color: "multicam_arid", size: "XXXL", variantId: 49862707347799 },
    ],
    accessoryMappings: [
      {
        stepId: "visor",
        optionValue: "clear",
        productHandle: "cookie-g35-visor",
        variantId: 46957506560343,
        price: 59,
      },
      {
        stepId: "visor",
        optionValue: "photochromic",
        productHandle: "cookie-g35-visor",
        variantId: 47911860601175,
        price: 94,
      },
      {
        stepId: "visor",
        optionValue: "blue",
        productHandle: "cookie-g35-visor",
        variantId: 46957506462039,
        price: 74,
      },
      {
        stepId: "visor",
        optionValue: "orange",
        productHandle: "cookie-g35-visor",
        variantId: 46957506494807,
        price: 74,
      },
      {
        stepId: "visor",
        optionValue: "tint",
        productHandle: "cookie-g35-visor",
        variantId: 46957506527575,
        price: 64,
      },
      {
        stepId: "side_plates",
        optionValue: "black_g35",
        productHandle: "cookie-g35-side-plates",
        variantId: 46950067437911,
        price: 40,
      },
      {
        stepId: "side_plates",
        optionValue: "black_loop",
        productHandle: "cookie-g35-side-plates",
        variantId: 46950067470679,
        price: 40,
      },
      {
        stepId: "side_plates",
        optionValue: "black_camo",
        productHandle: "cookie-g35-side-plates",
        variantId: 46950067503447,
        price: 40,
      },
      {
        stepId: "side_plates",
        optionValue: "blue_g35",
        productHandle: "cookie-g35-side-plates",
        variantId: 46950067536215,
        price: 40,
      },
      {
        stepId: "side_plates",
        optionValue: "blue_loop",
        productHandle: "cookie-g35-side-plates",
        variantId: 46950067568983,
        price: 40,
      },
      {
        stepId: "side_plates",
        optionValue: "blue_camo",
        productHandle: "cookie-g35-side-plates",
        variantId: 46950067601751,
        price: 40,
      },
      {
        stepId: "side_plates",
        optionValue: "purple_g35",
        productHandle: "cookie-g35-side-plates",
        variantId: 46950067634519,
        price: 40,
      },
      {
        stepId: "side_plates",
        optionValue: "purple_loop",
        productHandle: "cookie-g35-side-plates",
        variantId: 46950067667287,
        price: 40,
      },
      {
        stepId: "side_plates",
        optionValue: "purple_camo",
        productHandle: "cookie-g35-side-plates",
        variantId: 46950067700055,
        price: 40,
      },
      {
        stepId: "side_plates",
        optionValue: "red_g35",
        productHandle: "cookie-g35-side-plates",
        variantId: 46950067732823,
        price: 40,
      },
      {
        stepId: "side_plates",
        optionValue: "red_loop",
        productHandle: "cookie-g35-side-plates",
        variantId: 46950067765591,
        price: 40,
      },
      {
        stepId: "side_plates",
        optionValue: "red_camo",
        productHandle: "cookie-g35-side-plates",
        variantId: 46950067798359,
        price: 40,
      },
      {
        stepId: "side_plates",
        optionValue: "green_g35",
        productHandle: "cookie-g35-side-plates",
        variantId: 46950067831127,
        price: 40,
      },
      {
        stepId: "side_plates",
        optionValue: "green_loop",
        productHandle: "cookie-g35-side-plates",
        variantId: 46950067863895,
        price: 40,
      },
      {
        stepId: "side_plates",
        optionValue: "green_camo",
        productHandle: "cookie-g35-side-plates",
        variantId: 46950067896663,
        price: 40,
      },
      {
        stepId: "side_plates",
        optionValue: "orange_g35",
        productHandle: "cookie-g35-side-plates",
        variantId: 46950067929431,
        price: 40,
      },
      {
        stepId: "side_plates",
        optionValue: "orange_loop",
        productHandle: "cookie-g35-side-plates",
        variantId: 46950071763287,
        price: 40,
      },
      {
        stepId: "side_plates",
        optionValue: "orange_camo",
        productHandle: "cookie-g35-side-plates",
        variantId: 46950071796055,
        price: 40,
      },
      {
        stepId: "side_plates",
        optionValue: "gray_g35",
        productHandle: "cookie-g35-side-plates",
        variantId: 46950071828823,
        price: 40,
      },
      {
        stepId: "side_plates",
        optionValue: "gray_loop",
        productHandle: "cookie-g35-side-plates",
        variantId: 46950071861591,
        price: 40,
      },
      {
        stepId: "side_plates",
        optionValue: "gray_camo",
        productHandle: "cookie-g35-side-plates",
        variantId: 46950071894359,
        price: 40,
      },
      {
        stepId: "side_plates",
        optionValue: "pink_g35",
        productHandle: "cookie-g35-side-plates",
        variantId: 46950071927127,
        price: 40,
      },
      {
        stepId: "side_plates",
        optionValue: "pink_loop",
        productHandle: "cookie-g35-side-plates",
        variantId: 46950071959895,
        price: 40,
      },
      {
        stepId: "side_plates",
        optionValue: "pink_camo",
        productHandle: "cookie-g35-side-plates",
        variantId: 46950071992663,
        price: 40,
      },
      {
        stepId: "side_plates",
        optionValue: "yellow_g35",
        productHandle: "cookie-g35-side-plates",
        variantId: 46950072025431,
        price: 40,
      },
      {
        stepId: "side_plates",
        optionValue: "yellow_loop",
        productHandle: "cookie-g35-side-plates",
        variantId: 46950072058199,
        price: 40,
      },
      {
        stepId: "side_plates",
        optionValue: "yellow_camo",
        productHandle: "cookie-g35-side-plates",
        variantId: 46950072090967,
        price: 40,
      },
      {
        stepId: "top_plate",
        optionValue: "purple",
        productHandle: "cookie-g35-top-plate",
        variantId: 46950423462231,
        price: 66,
      },
      {
        stepId: "top_plate",
        optionValue: "black",
        productHandle: "cookie-g35-top-plate",
        variantId: 46950423494999,
        price: 66,
      },
      {
        stepId: "top_plate",
        optionValue: "electric_blue",
        productHandle: "cookie-g35-top-plate",
        variantId: 46950423527767,
        price: 66,
      },
      {
        stepId: "top_plate",
        optionValue: "charcoal",
        productHandle: "cookie-g35-top-plate",
        variantId: 46950423560535,
        price: 66,
      },
      {
        stepId: "top_plate",
        optionValue: "lime",
        productHandle: "cookie-g35-top-plate",
        variantId: 46950423593303,
        price: 66,
      },
      {
        stepId: "top_plate",
        optionValue: "dark_blue",
        productHandle: "cookie-g35-top-plate",
        variantId: 46950423626071,
        price: 66,
      },
      {
        stepId: "top_plate",
        optionValue: "orange",
        productHandle: "cookie-g35-top-plate",
        variantId: 46950423658839,
        price: 66,
      },
      {
        stepId: "top_plate",
        optionValue: "fluro_pink",
        productHandle: "cookie-g35-top-plate",
        variantId: 46950423691607,
        price: 66,
      },
      {
        stepId: "top_plate",
        optionValue: "white",
        productHandle: "cookie-g35-top-plate",
        variantId: 46950423724375,
        price: 66,
      },
      {
        stepId: "top_plate",
        optionValue: "yellow",
        productHandle: "cookie-g35-top-plate",
        variantId: 46950423757143,
        price: 66,
      },
      {
        stepId: "top_plate",
        optionValue: "red",
        productHandle: "cookie-g35-top-plate",
        variantId: 46950423789911,
        price: 66,
      },
      {
        stepId: "top_plate",
        optionValue: "royal_blue",
        productHandle: "cookie-g35-top-plate",
        variantId: 46950423822679,
        price: 66,
      },
      {
        stepId: "top_plate",
        optionValue: "tactical_green",
        productHandle: "cookie-g35-top-plate",
        variantId: 46950423855447,
        price: 66,
      },
      {
        stepId: "top_plate",
        optionValue: "multicam_arid",
        productHandle: "cookie-g35-top-plate",
        variantId: 49862836978007,
        price: 96,
      },
    ],
    upsells: [
      {
        id: "utility_top_plate",
        label: "Cookie G35 Utility Top Plate",
        description:
          "Camera mounting and cutaway system with roller base, handle, and lock mechanism. Replaces standard top plate.",
        productHandle: "cookie-g35-utility-top",
        variantId: 46951750074711,
        price: 144,
        image:
          "https://cdn.shopify.com/s/files/1/0758/1191/4071/products/cookie-g35-utility-top-helmet-accessories-674656.png?v=1700827835",
      },
      {
        id: "roller_mount",
        label: "Full Face Roller Mount",
        description:
          "Billet aluminum camera mount with 75° angle adjustment. Designed to mitigate snagging risk.",
        productHandle: "full-face-roller-mount",
        variantId: 46966118482263,
        price: 124,
        image:
          "https://cdn.shopify.com/s/files/1/0758/1191/4071/products/full-face-roller-mount-helmet-accessories-228726.png?v=1700827920",
        variants: [
          {
            label: "GoPro Hero 9/10/11/12/13",
            variantId: 46966118482263,
            price: 124,
          },
          { label: "GoPro Max2", variantId: 53415920402775, price: 169 },
          { label: "Insta360 ONE RS", variantId: 48065105625431, price: 149 },
          { label: "Insta X3", variantId: 47570310660439, price: 149 },
          { label: "Insta X4", variantId: 49661744578903, price: 169 },
          { label: "Insta X4-Air", variantId: 53415920435543, price: 169 },
          { label: "Insta X5", variantId: 51893014888791, price: 169 },
        ],
      },
      {
        id: "skid_plate",
        label: "Cookie G35 Skid Plate",
        description:
          "Protective top plate for tunnel sessions and a low-profile configuration on the Cookie G35.",
        productHandle: "cookie-g35-skid-plate",
        variantId: 53727007637847,
        price: 66,
        image:
          "https://cdn.shopify.com/s/files/1/0758/1191/4071/files/G35-Skid-3-1000.webp?v=1780847401",
      },
    ],
  };
  function O() {
    const l = document.getElementById("g35-availability");
    if (l != null && l.textContent)
      try {
        const t = JSON.parse(l.textContent);
        if (
          t &&
          typeof t.variants == "object" &&
          typeof t.productionTimes == "object"
        )
          return t;
      } catch {}
  }
  async function A(l) {
    try {
      const t = await fetch(`/products/${l}?sections=g35-inventory-data`);
      if (!t.ok) return {};
      const i = ((await t.json())["g35-inventory-data"] ?? "").match(
        /data-g35-inventory[^>]*>([\s\S]*?)<\/script>/,
      );
      if (!i) return {};
      const n = JSON.parse(i[1]),
        o = {};
      for (const s of n) o[String(s.id)] = s.qty > 0;
      return o;
    } catch {
      return {};
    }
  }
  async function x() {
    const l = document.querySelector("[data-g35-configurator-root]");
    if (!l) return;
    const t = l.dataset.productUrl ?? "/products/cookie-g35-skydiving-helmet",
      e = l.dataset.locale ?? "en",
      a = g35LocalizeConfig(T(B), g35ReadTranslations()),
      i = O();
    let n;
    if (i) {
      n = { variants: { ...i.variants }, productionTimes: i.productionTimes };
      const s = i.accessoryHandles ?? [];
      if (s.length > 0) {
        const r = await Promise.all(s.map(A));
        for (const p of r) Object.assign(n.variants, p);
      }
    }
    new C(l, { config: a, productUrl: t, locale: e, availability: n, translations: g35ReadTranslations() }).mount();
  }
  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", x)
    : x();
})();
